import { GENDER } from "../../../utils/Constants";
import { DATE_TYPE } from "../../../utils/Types";

export const GET_ALL_CPTS_QUERY_KEY = "GET_ALL_CPTS_QUERY_KEY";
export const GET_COMMON_HISTORY_TABLE_DATA_QUERY_KEY =
  "analytics/case-history?page={page}&limit={API_DATA_LIMIT}{queryString}";
export const GET_CASE_DETAIL_QUERY_KEY = "case/{caseId}";
export const GET_CASE_SUMMARY_QUERY_KEY = "analytics/case-summary/{caseId}";
export const GET_CASE_OPTIONAL_MILESTONES_QUERY_KEY =
  "case/{caseId}/optional/milestone/revisions";
export const GET_SURGEONS_LIST_QUERY_KEY = "admin/{hospitalId}/surgeons";
export const GET_Anesthelogist_LIST_QUERY_KEY =
  "admin/{hospitalId}/anesthelogist";
export const GET_PROCEDURES_QUERY_KEY =
  "region-codes/procedures/search?region=";
export const GET_CASE_DOCUMENTATION_QUERY_KEY = "cases/{caseId}/form-entries";
export const GET_CODING_CASE_DETAILS_QUERY_KEY = "getCodingCaseDetails";
export const GET_CONSUMABLES_QUERY_KEY = "getConsumables";
export const GET_EQUIPMENT_CONCERN_QUERY_KEY = "getEquipmentConcern";
export const GET_OPERATIVE_NOTE_TAKES_QUERY_KEY = "getOperativeNoteTakes";
export const GET_OPERATIVE_NOTE_STRUCTURED_QUERY_KEY = "getOperativeNoteStructured";



export type ICDType = {
  icd_code: string;
  icd_description: string;
  icd_confidence: string;
  icd_rationale: string;
  icd_voice_note_quotes: Array<string>;
};

export enum CASE_STATUS {
  PLANNED = "PLANNED",
  ACTIVE = "ACTIVE",
  SUBMITTED = "SUBMITTED",
  SUSPENDED = "SUSPENDED",
  NO_SHOW = "NO_SHOW",
  ALL_CASES = "PLANNED,ACTIVE,SUBMITTED,SUSPENDED,NO_SHOW",
}

export type CASE_HISTORY_TABLE_ITEM = {
  id: string;
  caseId: number;
  otId: string;
  assignedSurgeon: string;
  mrn: string;
  patientName: string;
  otName: string;
  procedureId: string;
  procedureName: string;
  hospitalId: string;
  tenantId: string;
  submittedBy: string;
  submittedAt: string;
  createdAt: string;
  updatedAt: string;
  hasCptCodes: boolean;
  hasHcpcsCodes: boolean;
  autoComplete?: boolean;
  autoCompleteAt?: string | null;
  hasEquipmentIssue?: boolean;
  inconsistentTimestamps?:boolean;
};

export type MILESTONE_REVISION_LOG = {
  id: number;
  milestoneId: number | null;
  milestoneUUID: string | null;
  milestoneRevisedByUserId: number;
  milestoneRevisedByUserName: string;
  milestoneRevisedStartTime: string;
  milestoneRevisedEndTime: string;
  action: "start" | "end" | null;
  comment?: string | null;
  startTimeLoggedBy: string | null;
  endTimeLoggedBy: string | null;
  skipReason: string | null;
  skipReasonNote: string | null;
  createdAt: DATE_TYPE;
  updatedAt: DATE_TYPE;
};
export type OPTIONAL_MILESTONE_REVISION_LOG = Omit<
  MILESTONE_REVISION_LOG,
  "milestoneRevisedStartTime" | "startTimeLoggedBy"
>;

export type REVISION = {
  milestoneUuid: string;
  milestoneId: number;
  displayName: string;
  milestoneRevisionLogs: Array<MILESTONE_REVISION_LOG>;
  skipReason?: string;
  skipReasonNote?: string;
  skippable?: boolean;
  skipped?: boolean;
};

export type OPTIONAL_REVISION = {
  milestoneUuid: string;
  displayName: string;
  milestoneName?: string;
  milestoneId: number;
  milestoneRevisionLogs: Array<OPTIONAL_MILESTONE_REVISION_LOG>;
  revisions?: Array<OPTIONAL_MILESTONE_REVISION_LOG>;
  skipReason?: string;
  skipReasonNote?: string;
  skippable?: boolean;
  skipped?: boolean;
};

export type CASE_DETAIL_MILESTONE_REVISION = {
  id: number;
  milestoneId: number | null;
  milestoneUUID: string | null;
  milestoneRevisedByUserId: number;
  milestoneRevisedByUserName: string | null;
  milestoneStartTime: string | Date | null;
  milestoneEndTime?: string | Date | null;
  action: "start" | "end" | null;
  startTimeLoggedBy: string | null;
  endTimeLoggedBy: string | null;
  createdAt: DATE_TYPE;
  updatedAt: DATE_TYPE;
};

export type CASE_DETAIL_OPTIONAL_MILESTONE_REVISION = Omit<
  CASE_DETAIL_MILESTONE_REVISION,
  "milestoneStartTime" | "startTimeLoggedBy"
>;

export type MILESTONE = {
  id: number;
  milestoneId: string;
  order: number;
  usedBy: string | null;
  completedTimestamp: string | Date | number;
  startTime: string | Date | number;
  loggedBy: string | null;
  loggedById?: number | null;
  skipped: boolean;
  status?: string | null;
  skipReason?: string | null;
  skipReasonNote?: string | null;
  skippedAt?: string | Date | null;
  required?: boolean;
  optional?: boolean;
  skippable?: boolean;
  skipReasonRequired?: boolean;
  minimumGap?: boolean;
  minimumGapMinutes?: number;
  minimumGapErrorMessage?: string;
  activeColor: string;
  waitingText: string;
  tooltip: string;
  displayName: string;
  startTimeLoggedBy?: string | null;
  endTimeLoggedBy?: string | null;
  revisions: Array<CASE_DETAIL_MILESTONE_REVISION>;
};

export type OPTIONAL_MILESTONE_ITEM = {
  id: number;
  milestoneId: string;
  displayName: string;
  order: number;
  activeColor: string;
  waitingText: string;
  tooltip: string;
  completedTimestamp: string | Date | number | null;
  startTime: string | Date | number | null;
  usedBy: string | null;
  loggedBy: string | null;
  loggedById?: number | null;
  skipped: boolean;
  required?: boolean;
  minimumGap?: boolean;
  minimumGapMinutes?: number;
  skippable?: boolean;
  skipReasonRequired?: boolean;
  skipReason?: string | null;
  skipReasonNote?: string | null;
  skippedAt?: string | Date | null;
  startTimeLoggedBy?: string | null;
  endTimeLoggedBy?: string | null;
  isOptionalMilestone?: boolean;
  revisions: Array<CASE_DETAIL_OPTIONAL_MILESTONE_REVISION>;
};

export type CASE_DETAIL_TIMER_LOGS = {
  caseTime: string | number | null;
  currentWheelsIn: string | null;
  delayTime: string | number | null;
  currentWheelsOut: string | null;
  previousWheelOut: string | null;
  turnOverTime: string | number | null;
  previousProcedureEnd?: string | null;
  previousRoomClean?: string | null;
  currentProcedureStart?: string | null;
  currentRoomReady?: string | null;
  id: number;
};

export type ADDITIONAL_PROCEDURE = {
  id?: number;              
  procedureId: string;
  procedureName: string;
  cptCode: string;
  manuallyAdded?: boolean;
};

export type CASE_DETAIL = {
  id: number;
  startTime: Date;
  endTime: Date;
  actualStartTime: Date;
  actualEndTime: Date;
  procedureId: string;
  assignedSurgeon: string;
  assignedAnesthesiologist: string;
  anesthesiaType: Array<string>;
  remarks: string;
  timeoutTime?: string | Date | number | null;
  isFirstCase: boolean;
  isLastCase: boolean;
  anaesthesiaStart?: string | Date | number | null;
  anaesthesiaSkip?: boolean | null;
  otId: string;
  otName?: string;
  status: string;
  procedure: {
    name: string;
    procedureId: string;
    cptCode: string;
    milestones: Array<MILESTONE>;
    optionalMilestones?: Array<OPTIONAL_MILESTONE_ITEM>;
  };
  patient: {
    id: number;
    name?: string | null;
    firstName: string | null;
    lastName: string | null;
    mrn: string;
    dob: string | null | Date;
    gender?: GENDER | null;
    age?: number;
  };
  currentMilestone: MILESTONE;
  timerLogs: CASE_DETAIL_TIMER_LOGS;
  comments?: string | null;
  caseNotes?: Array<VOICE_NOTE>;
  timers?: Array<TIMER>;
  isDeleted?: boolean;
  missingMandatoryData?: boolean;
  inconsistentTimestamps?: boolean;
  actualDuration?: number | null;
  duration?: number | null;
  autoComplete?: boolean;
  autoCompleteAt?: string | null;
  hasCptCodes?: boolean;
  hasHcpcsCodes?: boolean;
  hasEquipmentIssue?: boolean;
  equipments?: Array<{ id: string; name?: string }>;
  participants: Array<PARTICIPANT>;
  submittedBy?: {
    userId: number | null;
    userName: string | null;
  };
  primarySurgeonStatus: string | null;
  secondSurgeon?: string;
  thirdSurgeon?: string;
  anesthesiaTechnicians?: Array<string>;
  scrubNurses?: Array<string>;
  equipmentId?: Array<string>;
  speciality1: string | null;
  speciality2: string | null;
  specialty1Id?: string | null;
  specialty2Id?: string | null;
  operationType: string | null;
  procedureNature: string;
  additionalProcedures?: Array<ADDITIONAL_PROCEDURE>;
};

export type VOICE_NOTE = {
  id: number;
  note: string;
  caseId: number;
  hospitalId: string;
  tenantId: string;
  tag: string;
  timestamp: string;
  loggedBy?: string | null;
  loggedById?: number | null;
  active: boolean;
  edited: boolean;
  updatedAt: string;
  classifications?: Array<VOICE_NOTE_CLASSIFICATON>;
  revisionLogs?: Array<VOICE_NOTE_REVISION_LOG>;
};

export type VOICE_NOTE_CLASSIFICATON = {
  colorCode: string;
  id?: number;
  isEnabled: boolean;
  isAIGenerated: boolean;
  noteId?: number;
  type: string;
};

export type VOICE_NOTE_REVISION_LOG = {
  id?: number | string | null;
  caseNoteId?: number | null;
  caseId?: number | null;
  previousNote: string;
  revisedNote: string;
  action?: string | null;
  revisedByUserId?: number | null;
  revisedByUserName?: string | null;
  createdAt?: DATE_TYPE | null;
};

export type TIMER = {
  id: number;
  type: TIMER_TYPE;
  status: TIMER_STATUS;
  startTime?: Date | null;
  resumeTime?: Date | null;
  pauseTime?: Date | null;
  endTime?: Date | null;
  duration: number;
  completedDuration: number;
  elapsed?: number | null;
  description?: string | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  dismissTime?: Date | null;
  trigger?: string | null;
  timerlogs: Array<TIMER_LOGS>;
};

export type NOTIFICATION = {
  id: number;
  message: string;
  recipientType: NOTIFICATION_RECIPIENT_TYPE;
  recipientValue: string;
  notificationType: NOTIFICATION_TYPE;
  createdAt: DATE_TYPE;
  updatedAt: DATE_TYPE;
  caseId: number;
  hospitalId: string;
  tenantId: string;
  loggedBy: string;
  loggedById: number;
  loggedAt: DATE_TYPE;
  recipients: Array<{
    id: number;
    userId: number;
    userName: string;
  }>;
};

export enum NOTIFICATION_TYPE {
  SMS = "SMS",
  EMAIL = "EMAIL",
  PUSH = "PUSH",
}

export enum NOTIFICATION_RECIPIENT_TYPE {
  USER = "USER",
  ROLE = "ROLE",
  DEPARTMENT = "DEPARTMENT",
}

export enum TIMER_TYPE {
  TIMER = "TIMER",
  ALARM = "ALARM",
  STOPWATCH = "STOPWATCH",
}

export enum TIMER_STATUS {
  PAUSED = "PAUSED",
  RUNNING = "RUNNING",
  STOPPED = "STOPPED",
}

export type TIMER_LOGS = {
  id: number;
  timerId: number;
  caseId: number;
  previousStatus: TIMER_STATUS;
  newStatus: TIMER_STATUS;
  userId: number;
  userName: string;
  timestamp: DATE_TYPE;
  metaData: {
    action: string;
    endTime: DATE_TYPE;
    pauseTime: DATE_TYPE;
    resumeTime: DATE_TYPE;
    description?: string;
    duration?: number;
  };
};

export type CASE_FILTER_STATE = {
  dateRange: {
    from?: Date | string | null;
    to?: Date | string | null;
  };
  patientName: string;
  mrn: Array<string>;
  caseIds: Array<string>;
  ots: Array<string>;
  procedureIds: Array<string>;
  attendingSurgeonNames: Array<string>;
  submittedBy: Array<string>;
  autoClosed?: "true" | "false" | null;
  inconsistentTimestamps?: "true" | "false" | null;
};

export type SURGEON = {
  tenantId: string;
  hospitalId: string;
  firstName: string;
  lastName: string;
  phoneNumber: number | null;
  email: string | null;
  emrId: number | null;
  emrName: string | null;
  emrResourceType: string | null;
  uuid: string;
  updatedAt: string | Date | number;
  createdAt: string | Date | number;
  primaryColor?: string;
  secondaryColor?: string;
};

export type OT_ROOM = {
  name: string;
  procedure: string;
  updatedAt: string;
  createdAt: string;
  tenantId: string;
  hospitalId: string;
  uuid: string;
  rbpName: string;
};

export type ANESTHELOGIST = {
  tenantId: string;
  hospitalId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  emrId: string;
  emrName: string;
  emrResourceType: string;
  uuid: string;
  updatedAt: string;
  createdAt: string;
};

export enum PARTICIPANT_TYPE {
  SURGEON = "SURGEON",
  ANESTHESIOLOGIST = "ANESTHESIOLOGIST",
}

export interface PARTICIPANT {
  emrName: string;
  emrResourceType: string;
  emrId: string;
  participantPrimaryColor?: string;
  participantSecondaryColor?: string;
  participantType: PARTICIPANT_TYPE;
  participantId: string;
  participantFirstName: string;
  participantLastName: string;
  participantPhone: string;
  participantEmail: string;
}

export type CASE_BULK_UPLOAD_DETAIL = {
  status: string;
  message: string;
  data?: Array<{
    rowNumber: number;
  }>;
  failedRows?: Array<{
    rowNumber: number;
    errors: Array<string>;
    row: {
      "First name\n(text)": string;
      "Last name\n(text)": string;
      "MRN \n(#)": string;
      "DOB (dd/mm/yyyy)\n(Optional)": string;
      "Search CPT - Procedure Name\n(use E2 to filter Procedures in Column F for any row)": string;
      "CPT - Procedure Name\n(select '##### - Desc' from list)": string;
      "Scheduled Date\n(dd/mm/yyyy)": string;
      "Scheduled Start Time\n(hh:mm) ": string;
      "Duration (Min)\n(###)": string;
      "OT\n(OT # - from picklist)": string;
      "Primary Surgeon Full Name\n(Dr. Text Text)": string;
      "Primary Surgeon Mobile\n((+###) ## ### ####) \n(Optional)": string;
      "Primary Surgeon Email \n(text@text.text)\n(Optional)": string;
      "Anesthesiologist Full Name \n(Dr. Text Text)\n(Optional)": string;
      "Anesthesiologist Mobile\n((+###) ## ### ####) \n(Optional)": string;
      "Anesthesiologist Email \n(text@text.text)\n(Optional)": string;
    };
  }>;
  canEdit: boolean;
  canReupload: boolean;
};

export enum CASE_TIMELINE_TYPE {
  MILESTONE = "milestone",
  VOICE_NOTE = "note",
  TIMER = "timer",
  NOTIFICATION = "notification",
  CONFLICT_ALERT = "conflict_alert",
}

export type MILESTONE_TIMELINE = {
  type: CASE_TIMELINE_TYPE.MILESTONE;
  title: string | undefined;
  revision?: Array<MILESTONE_REVISION_LOG | OPTIONAL_MILESTONE_REVISION_LOG>;
  timestamp?: DATE_TYPE;
  loggedBy?: string | null;
  milestoneId: number;
  milestoneUUID: string;
  milestoneKey?: string;
  caseId?: string;
  otId?: string;
  isOptionalMilestone?: boolean;
  createdAt: DATE_TYPE;
  isEarlierThanPrior?: boolean;
  isAmPmCheck?: boolean;
  isMinimumGapViolation?: boolean;
  isHardBlock?: boolean;
  priorMilestoneName?: string;
  priorMilestoneTime?: DATE_TYPE;
  minimumGapMinutes?: number;
  inconsistentTimestamps?:boolean;
  skipped?: boolean;
  skipReason?: string;
  skipReasonNote?: string;
};
export type VOICE_NOTE_TIMELINE = {
  type: CASE_TIMELINE_TYPE.VOICE_NOTE;
  id?: number | null;
  note: string;
  timestamp: DATE_TYPE;
  updatedAt?: DATE_TYPE | null;
  loggedBy?: string | null;
  classifications?: Array<VOICE_NOTE_CLASSIFICATON>;
  revisionLogs?: Array<VOICE_NOTE_REVISION_LOG>;
  caseId?: string;
  createdAt: DATE_TYPE;
};
export type TIMER_TIMELINE = {
  title: string;
  type: CASE_TIMELINE_TYPE.TIMER;
  timerType?: TIMER_TYPE;
  id?: number | null;
  timerId?: number;
  desc?: string | null;
  timestamp: DATE_TYPE;
  loggedBy?: string | null;
  duration?: number;
  caseId?: string;
  action?: string;
  timerCreatedAt?: Date | null;
  createdAt: DATE_TYPE;
};

export type NOTIFICATION_TIMELINE = {
  type: CASE_TIMELINE_TYPE.NOTIFICATION;
  id?: number | null;
  sendTo: string;
  message: string;
  loggedBy: string;
  createdAt: DATE_TYPE;
};

export type CONFLICT_ALERT_TIMELINE = {
  type: CASE_TIMELINE_TYPE.CONFLICT_ALERT;
  id?: number | null;
  conflictType: SMS_DELIVERY_LOG_TYPE;
  sentTo: string | null;
  createdAt: DATE_TYPE;
};

export enum CONFLICT_ALERT_TYPE {
  ANESTHETIST_NEXT_CASE_IMPACT = "ANESTHETIST_NEXT_CASE_IMPACT",
  SURGEON_NEXT_CASE_IMPACT = "SURGEON_NEXT_CASE_IMPACT",
  EQUIPMENT_CONFLICT = "EQUIPMENT_CONFLICT",
}

export enum OPTIONAL_MILESTONE_TRACKER_STEPS {
  ANESTHESIA_START = "Anesthesia Start",
  PATIENT_ASLEEP = "Patient's Asleep",
  TIMEOUT_TIME = "Timeout",
  PATIENT_AWAKE = "Patient's Awake",
}

export enum MILESTONE_TRACKER_STEPS {
  ROOM_READY = "Room Ready",
  WHEELS_IN = "Wheels In",
  PATIENT_READY = "Patient Ready",
  PROCEDURE_START = "Procedure Start",
  PROCEDURE_END = "Procedure End",
  READY_TO_EXIT = "Ready to Exit",
  WHEELS_OUT = "Wheels Out",
  ROOM_CLEAN = "Room Clean",
}

export enum USER_ACTION {
  TAP = "tap",
  VOICE = "voice",
}

export const GET_MILESTONE_CONFIG_QUERY_KEY =
  "hospital/{hospitalId}/milestone-config";

export type MILESTONE_CONFIG_ITEM = {
  name: string;
  displayOrder: number;
  active: boolean;
  required: boolean;
  minimumGap: boolean;
  minimumGapMinutes: number;
  optional: boolean;
};

export type MODIFIED_CASE_DOCUMENTATION = {
  sectionName: string;
  actualEntries: number;
  entity: Array<MODIFIED_CASE_DOCUMENTATION_ENTITY>;
};

export type MODIFIED_CASE_DOCUMENTATION_ENTITY = {
  entityName: string;
  entries: Array<CASE_DOCUMENTATION_ENTRY>;
  totalEntries: number;
  latestEntry: CASE_DOCUMENTATION_ENTRY | null;
  entityType: string;
  enumValues: Array<string>;
};

export type CASE_DOCUMENTATION = {
  id: number;
  caseId: number;
  moduleId: string;
  moduleName: string;
  sectionName: string;
  entityName: string;
  entityType: string;
  entityValue: string | null;
  enumValues: Array<string>;
  hint: string;
  referenceVoiceNote: string | null;
  createdBy: string;
  updatedBy: string | null;
  confidence: null | number;
  evidence: null | string;
  inference: null | string;
  createdAt: DATE_TYPE;
  updatedAt: DATE_TYPE;
};

export type CASE_DOCUMENTATION_ENTRY = {
  id: number;
  entityValue: string | null;
  confidence: number | null;
  transcript: string | null;
  evidence: string | null;
  inference: string | number | null;
  updatedBy: string | null;
  updatedByUserId: number | null;
  updatedByAi: boolean;
  createdAt: DATE_TYPE;
  updatedAt: DATE_TYPE;
};

export type GROUPED_CASE_DOCUMENTATION = {
  formEntityMappingUuid: string;
  moduleName: string;
  sectionName: string;
  entityName: string;
  entityType: string;
  enumValues: Array<string>;
  hint: string;
  entries: Array<CASE_DOCUMENTATION_ENTRY>;
  totalEntries: number;
  latestEntry: CASE_DOCUMENTATION_ENTRY | null;
};

export enum SMS_DELIVERY_LOG_TYPE {
  ANESTHETIST_NEXT_CASE_IMPACT = "ANESTHETIST_NEXT_CASE_IMPACT",
  SURGEON_NEXT_CASE_IMPACT = "SURGEON_NEXT_CASE_IMPACT",
  EQUIPMENT_CONFLICT = "EQUIPMENT_CONFLICT",
}

export enum SMS_CARRIER_TYPE {
  TELNYX = "TELNYX",
  EANDS = "EANDS",
}
export type SMS_DELIVERY_LOG = {
  id: number;
  scheduledTriggerTime: DATE_TYPE | null;
  type: SMS_DELIVERY_LOG_TYPE; // Only "ANESTHETIST_NEXT_CASE_IMPACT" or "SURGEON_NEXT_CASE_IMPACT"
  smsCarrierType: SMS_CARRIER_TYPE; // "TELNYX" or "EANDS"
  lastTriggerTime: DATE_TYPE | null;
  retryCount: number;
  deliveryStatus: string; // Must contain "Completed"
  caseId: string | null;
  jobId: string | null;
  messageId: string | null;
  receivedAt: DATE_TYPE | null;
  deliveredAt: DATE_TYPE | null;
  sentAt: DATE_TYPE | null;
  transactionId: string | null;
  completedAt: DATE_TYPE | null;
  failureReason: string | null;
  recipients: string | null; // Individual recipient role (e.g., "Anesthesiologist", "OT Manager", "Charge Nurse")
  alertType: string | null;
  createdAt: DATE_TYPE;
  updatedAt: DATE_TYPE;
  metaData: any;
  equipments: Array<EQUIPMENT_TYPE>;
};
export type ANESTHESIA_TYPE = {
  value: string;
  label: string;
};

export type EQUIPMENT_TYPE = {
  id: string;
  uuid: string;
  hospitalId: string;
  tenantId: string;
  name: string;
  type: string;
  availabilityStatus: string;
  serviceNeedsFlagged: boolean;
  operationalStatus: string;
  createdAt: DATE_TYPE;
  updatedAt: DATE_TYPE;
  totalServiceLogs: number;
};

export type EQUIPMENT_TYPE_LIST_RESPONSE = Array<EQUIPMENT_TYPE>;
